import { unknown } from "zod";

declare global {
    interface Array<T> {
        trim(): T[];
    }
    interface ArrayConstructor {
        count(arr: unknown[]): number;
        toArray<T = unknown>(obj: unknown): T[];
    }
}

Array.prototype.trim = function <T>(): T[] {
    return this.filter((item: T) => item != null) as T[];
}

Array.count = function (arr: unknown[]): number {
    if (!Array.isArray(arr)) {
        return 0;
    }
    return arr.length;
};

Array.toArray = function <T = unknown>(obj: unknown): T[] {
    if (Array.isArray(obj)) {
        return obj;
    }
    return [] as T[];
};

export default {}